<template>
  <portal
    to="modal"
    :disabled="!isShow"
    :style="{ position: 'absolute' }"
  >
    <ar-modal
      :is-open="isShow"
      class="ticketspice-modal"
      header="Connect To Ticketspice"
      width="590px"
      :mobile="$arMediaQuery.window.maxWidth('xs')"
      @close="handleCloseClick"
    >
      <div
        slot="body"
        :class="[
          'ticketspice-modal-body',
          $arMediaQuery.window.maxWidth('xs') && 'u-padding-x-3',
        ]"
      >
        <ar-field
          label="Account Name"
          class="u-margin-top-5"
        >
          <ar-input
            v-model="accountName"
            name="accountName"
            placeholder="Please enter your Ticketspice account name"
            id="ticketspice-account-name-input"
            type="text"
            data-test-id="ticketspice-account-name-input"
          />
        </ar-field>
        <ar-field
          label="API Key"
          class="u-margin-top-5"
        >
          <ar-input
            v-model="apiKey"
            name="apiKey"
            placeholder="Please enter your Ticketspice API key"
            id="ticketspice-api-key-input"
            type="password"
            data-test-id="ticketspice-api-key-input"
          />
        </ar-field>
      </div>
      <div
        slot="body"
        :class="[
          'ticketspice-modal-body',
          $arMediaQuery.window.maxWidth('xs') && 'u-padding-x-3',
        ]"
      >
      </div>
      <div
        slot="footer"
        :class="[
          'ticketspice-modal-footer',
          $arMediaQuery.window.maxWidth('xs') && 'u-padding-x-3',
        ]">
        <ar-simple-button
          text="Confirm"
          :loading="loading"
          :disabled="confirmButtonDisabled"
          :style="{ width: '108px' }"
          @click="handleConfirmClick"
          id="ticketspice-modal-confirm-button"
          data-test-id="ticketspice-modal-confirm-button"
        />
      </div>
    </ar-modal>
  </portal>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: 'TicketspiceModal',
  components: {},
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      apiKey: null,
      accountName: null
    };
  },

  computed: {
    confirmButtonDisabled() {
      return !this.apiKey || !this.accountName;;
    }
  },

  watch: {
    isShow(val) {
      if (val) {
        this.apiKey = null;
        this.accountName = null;
      }
    },
  },

  methods: {
    ...mapActions([
      'ticketspiceIntegration/CREATE_TICKETSPICE_INTEGRATION',
      'ticketspiceIntegration/FETCH_INTEGRATION'
    ]),
    async fetchIntegration() {
      const success = await this['ticketspiceIntegration/FETCH_INTEGRATION']()
      return success;
    },

    async handleConfirmClick() {
      this.errorMessage = null;
      this.httpStatus = null;
      const apiKey = this.apiKey;
      const accountName = this.accountName;
      const response = await this['ticketspiceIntegration/CREATE_TICKETSPICE_INTEGRATION']({
        apiKey,
        accountName
      });
      if (response) {
        if (this.$route.path != '/settings/integrations/ticketspice') {
          await this.$router.push({ path: '/settings/integrations/ticketspice' });;
        }
        else {
          this.fetchIntegration();
        }
        this.$emit('cancel');
      }
      else {
        this.errorMessage = response.message;
        this.httpStatus = response.httpStatusCode;
      }
    },
    handleCloseClick() {
      this.$emit('cancel');
    }
  }
};
</script>

<style lang="scss" scoped>
.ticketspice-modal {
  .ticketspice-modal-body {
    padding: 20px 30px 30px;

    &:nth-child(2) {
      border-top: 1px solid $blueGrey500;
    }
  }
  .ticketspice-modal-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 25px 30px;
    height: 100px;
  }
}
</style>
